import getNumberTranslation from '../assets/numbers/numberTable'

import cleanString, { cleanNumberString } from './clean-string'
import distance from './string-distance'
import getPhraseLength from './getPhraseLength'
import convertTime from './convertTime'

const hasNumberRegex = /\d/
const numTranslationLangs = new Set(['es', 'en', 'fr', 'it'])

const checkPronunciation = (userInput, text, difficulty = 'normal', lang = null) => {
  let phrase_length = getPhraseLength(text, userInput)
  let cleanText = cleanString(text)
  let cleanUserInput = cleanString(userInput)

  if (cleanUserInput === cleanText) {
    return true
  }
  // detect if number in user input and not in text
  if (numTranslationLangs.has(lang) && hasNumberRegex.test(cleanUserInput) && !hasNumberRegex.test(cleanText)) {
    cleanUserInput = cleanString(handleTranslateNumbers(userInput, cleanText, lang))
    cleanText = cleanString(cleanNumberString(text, lang))
    let distanceScore = distance(cleanUserInput, cleanText)

    if (cleanUserInput === cleanText || distanceScore <= 2) {
      return true
    }
  } else if (numTranslationLangs.has(lang) && hasNumberRegex.test(cleanText) && !hasNumberRegex.test(cleanUserInput)) {
    // detect if number in text and not in user input
    cleanText = cleanString(handleTranslateNumbers(text, cleanUserInput, lang))
    cleanUserInput = cleanString(cleanNumberString(userInput, lang))
    let distanceScore = distance(cleanUserInput, cleanText)

    if (cleanUserInput === cleanText || distanceScore <= 2) {
      return true
    }
  }

  if (Array.isArray(cleanText)) {
    const match = getClosestMatch(cleanText, cleanUserInput)

    cleanText = match.value
    phrase_length = text && match.value && match.index && text.split('+')[match.index].trim().split(' ').length
  }

  let threshold

  if (cleanText && cleanText.length <= 2) {
    // if the phrase is less or equal to 2 words
    threshold = 0
  } else if (!hasNumberRegex.test(cleanUserInput) && !hasNumberRegex.test(cleanText)) {
    // if the user input and text do not contain numbers
    threshold = getDistanceThreshold(phrase_length, difficulty)
  } else if (hasNumberRegex.test(cleanUserInput) || hasNumberRegex.test(cleanText)) {
    // if the user input or text contain numbers
    threshold = 0
  } else {
    // default case
    threshold = 2
  }

  let distanceScore = distance(cleanUserInput, cleanText)

  if ((Array.isArray(cleanText) && cleanText.indexOf(cleanUserInput) > -1) || distanceScore <= threshold) {
    return true
  } else {
    return false
  }
}

export default checkPronunciation

const getClosestMatch = (cleanText, cleanUserInput) => {
  return cleanText.reduce(
    (prev, curr, index) => {
      const currDistance = distance(cleanUserInput, curr)

      if (currDistance < prev.distance) {
        return {
          distance: currDistance,
          value: curr,
          index,
        }
      } else {
        return prev
      }
    },
    { distance: Infinity, value: '', index: 0 },
  )
}

const getDistanceThreshold = (phrase_length, difficulty) => {
  switch (difficulty) {
    case 'easy':
      if (phrase_length > 6) {
        // 7 + word phrases get Squaroot phrase_length + 2 (Ex 9 word phrase = (sqrt(9) + 2 => 5 characters))
        return Math.sqrt(phrase_length) + 2
      } else if (phrase_length > 2) {
        // 3 - 6 words long get phrase_length - 1 characters wrong (example 4 word phrase gets 3 chars)
        return phrase_length - 1
      } else {
        //Two words and under get 2 character leeway
        return 2
      }
    case 'normal':
      if (phrase_length > 4) {
        // 5 + word phrases get square Root of length (ex 9 word phrase gets 3 char, 16 word phrases...4 char)
        return Math.sqrt(phrase_length)
      } else if (phrase_length > 1) {
        //2 - 4 words long get phrase_length / 2 characters wrong (example 4 word phrase gets 2 char)
        return phrase_length / 2
      } else {
        //Single words get 1 char
        return 1
      }
    case 'hard':
      // No character forgiviness
      return 0
    case 'confidence':
      if (phrase_length > 6) {
        // Very lenient for longer phrases: sqrt(length) + 4
        return Math.sqrt(phrase_length) + 4
      } else if (phrase_length > 2) {
        // 3-6 words get phrase_length characters wrong
        return phrase_length
      } else {
        // Short phrases get 3 character leeway
        return 3
      }
    default:
      return phrase_length * 0.5
  }
}

// function hasNumber(myString) {
//   return /\d/.test(myString);
// }
// function getNumber(myString) {
//   if (!myString || !myString.match) return "";
//   const number = myString.match(/\d+/g);
//   return Number(number);
// }
// function replaceNumberWithText(myString, number) {
//   if (!myString || !myString.replace) return "";
//   return myString.replace(/\d+/g, number);
// }

const digitsRegex = /\d+/g
///\b(\d{1,2})[:h]?(\d{2})?\b/; ///\b(1[0-9]|2[0-3]|[0-9])[:h][0-5][0-9]\s?(a\.m\.|p\.m\.)?\b/i;
const handleTranslateNumbers = (userText, cardText, lang) => {
  let result = userText

  // if theres a time in the user input, translate it, otherwise return the userText
  result = convertTime(userText, cardText, lang)

  let matches = result.matchAll(digitsRegex)

  // any remaining numbers will be translated that werent translated in the time function
  for (const match of matches) {
    const translation = getNumberTranslation(match[0], lang)

    result = result.replace(match[0], translation)
  }

  return result
}
